import { cRegion } from "./config";
import siteConfig from "./siteConfig";

// export const s3PoolConf = {
//     Auth: {
//         identityPoolId: process.env.REACT_APP_INDENTITYPOOLID,
//         region: process.env.REACT_APP_REGION,
//         userPoolId: process.env.REACT_APP_COGNITOUSERPOOLID,
//         userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
//     },
//     Storage: {
//         AWSS3: {
//             bucket: process.env.REACT_APP_BUCKET,
//             region: process.env.REACT_APP_REGION,
//         }
//     }
// };

export const s3PoolConf = {
    Auth: {
        identityPoolId: siteConfig.constants.identityPoolId,
        region: cRegion,
        userPoolId: siteConfig.constants.userPoolId,
        userPoolWebClientId: siteConfig.constants.userPoolWebClientId,
    },
    Storage: {
        AWSS3: {
            bucket: siteConfig.constants.bucket,
            region: cRegion,
        }
    }
};